module.exports = __webpack_public_path__ + "img/white-footer-1.63c3d16d.png";